import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import JustAskList from 'justAskComponents/JustAskList';

const JustAskPanel = (props) => {

    const {
        justAskDetails,
        clearWorkOrderDetail,
        orderId,
        header,
        justAskActions,
        accountNumber,
        style,
        category,
        showRefreshButton,
        detailKey,
        orderStatus
    } = props;

    const hasDetails = justAskDetails && justAskDetails.get('details') && justAskDetails
        .get('details')
        .count() > 0;

    const loading = justAskDetails && justAskDetails.get('loading');

    return (
        <Panel
            style={style}
            loading={loading}
            hasDetails={hasDetails}
            orderId={orderId}
            detailKey={detailKey}
            showRefreshButton={showRefreshButton}
            clearWorkOrderDetail={clearWorkOrderDetail}
            header={header}>
            <div style={{}}>

                <JustAskList
                    orderStatus={orderStatus}
                    category={category}
                    orderId={orderId}
                    accountNumber={accountNumber}
                    justAskDetails={justAskDetails}
                    justAskActions={justAskActions}/>
            </div>
        </Panel>
    );
};

JustAskPanel.propTypes = {
    justAskDetails: PropTypes.object,
    orderStatus: PropTypes.object,
    clearWorkOrderDetail: PropTypes.func,
    orderId: PropTypes.string,
    header: PropTypes.string,
    justAskActions: PropTypes.object,
    accountNumber: PropTypes.string,
    category: PropTypes.string,
    style: PropTypes.object,
    showRefreshButton: PropTypes.bool,
    detailKey: PropTypes.string
};
export default JustAskPanel;



// WEBPACK FOOTER //
// ./src/components/just-ask/JustAskPanel.js